import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import api from '@/lib/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <h1 className="text-xl font-extrabold mb-2">Reset your password</h1>
        <p className="text-sm text-ink-3 mb-6">
          Enter your email and we'll send you a link to reset your password.
        </p>

        {sent ? (
          <div>
            <div
              className="bg-green-bg text-green text-sm font-semibold px-4 py-3 rounded-lg mb-6"
            >
              If an account exists with that email, a password reset link has been sent. Check your inbox.
            </div>
            <Link to="/login" className="text-xs text-orange font-semibold hover:underline">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-[11px] font-semibold text-ink-3 mb-1.5">Email</label>
              <input
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                className="w-full px-3 py-2.5 text-sm font-mono rounded-lg bg-surface text-ink placeholder:text-ink-4 outline-none transition-all duration-200 border border-border focus:border-orange focus:shadow-[0_0_8px_rgba(249,115,22,0.15)]"
              />
            </div>

            {error && <p className="text-xs text-red font-semibold">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-lg text-sm font-bold text-white transition-all hover:brightness-110 disabled:opacity-50"
              style={{ background: 'linear-gradient(135deg, #f97316, #f59e0b)' }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <p className="text-xs text-ink-3 text-center">
              <Link to="/login" className="text-orange font-semibold hover:underline">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
